import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiArrowLeft } from 'react-icons/fi';

// === IMPORTY ZASOBÓW (Zostawiam Twoje ścieżki) ===
import logo from '../../img/orzel_logo_192.png';
// Jeśli nie masz NotebookBackground pod ręką w tym pliku, 
// po prostu usun ten import i komponent <NotebookBackground /> z JSX
import NotebookBackground from '../../img/NotebookBackground';

const SupportPage = () => {
  return (
    <div className="relative min-h-screen w-full flex flex-col bg-blue-950 text-[#F0F0F0]">
      {/* Tło (opcjonalne, jak w reszcie apki) */}
      <NotebookBackground />
      
      {/* === PROSTA NAWIGACJA === */}
      <nav className="relative z-50 w-full bg-blue-950 shadow-md">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="Matematly Logo" className="h-10 w-auto" />
            <span className="text-xl font-bold font-apotek uppercase tracking-wider">
              Matematly
            </span>
          </Link>
          
          <Link to="/" className="text-sm font-medium opacity-80 hover:opacity-100 flex items-center gap-2 transition-opacity">
            <FiArrowLeft />
            Wróć do strony głównej
          </Link>
        </div>
      </nav>

      {/* === GŁÓWNA TREŚĆ === */}
      <main className="relative z-10 flex-grow flex flex-col items-center justify-center px-4 text-center">
        
        <div className="bg-[#0a101f]/80 p-8 md:p-12 rounded-2xl border border-gray-700 shadow-2xl max-w-lg w-full backdrop-blur-sm">
          
          <div className="w-16 h-16 bg-[#E09F2E]/20 rounded-full flex items-center justify-center mx-auto mb-6 text-[#E09F2E]">
            <FiMail size={32} />
          </div>

          <h1 className="text-3xl font-bold font-apotek uppercase mb-4 tracking-wide">
            Wsparcie Techniczne
          </h1>
          
          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            Masz problem z aplikacją lub pytania dotyczące konta? <br/>
            Jesteśmy tu, aby Ci pomóc.
          </p>

          <a 
            href="mailto:kontakt@matematly.pl" 
            className="inline-flex items-center gap-3 bg-[#E09F2E] text-blue-950 px-8 py-4 rounded-lg text-lg font-bold font-apotek uppercase hover:scale-105 transition-transform shadow-lg"
          >
            <FiMail />
            Napisz do nas
          </a>

          <p className="mt-8 text-sm text-white/50">
            Odpowiadamy zazwyczaj w ciągu 24h.
            <br />
            Możesz też pisać bezpośrednio na: <span className="text-white select-all">kontakt@matematly.pl</span>
          </p>
        </div>

      </main>

      {/* === STOPKA (Uproszczona) === */}
      <footer className="relative z-10 py-8 text-center text-white/40 text-sm bg-blue-950 border-t border-white/5">
        <p>© {new Date().getFullYear()} Matematly Sp. z o.o. Wszelkie prawa zastrzeżone.</p>
        <div className="flex justify-center gap-4 mt-2">
             <Link to="/privacy-policy" className="hover:text-white">Polityka Prywatności</Link>
             <Link to="/terms-of-service" className="hover:text-white">Regulamin</Link>
        </div>
      </footer>

    </div>
  );
};

export default SupportPage;